<template>
    <div>
        <el-card class="self-el-card">
            <!-- 表单 -->
            <el-form ref="addPush" :rules="rules" :model='selectVal'
             label-width="200px" style='padding-top:20px;'>
                <p class="title">基本信息</p>
                <el-form-item label="标题：" prop='title'
                  class="is-required">
                     <el-input size="small"
                         v-model.trim="selectVal.title"
                         :min='0' class='width_short' ></el-input>
                </el-form-item>
                <el-form-item label="内容：" prop='content'
                  class="is-required">
                     <el-input size="small"
                         v-model.trim="selectVal.content"
                         :min='0' class='width_short' ></el-input>
                </el-form-item>
                <el-form-item label="推送时间：" class="is-required"
                 prop='pushTime'>
                    <datetime ref='datetime' :defaultTime='selectVal.pushTime'>
                    </datetime>
                </el-form-item>
                <el-form-item label="指令：" prop='command'
                  class="is-required">
                     <el-input size="small"
                         v-model.trim="selectVal.command"
                         :min='0' class='width_short' ></el-input>
					<span class="click_word" @click='goCommand'>获取指令 ></span>
                </el-form-item>
                <p class="title">推送对象</p>
                <el-radio-group v-removeAriaHidden v-model='selectVal.rule'
                 style='margin-left: 118px;line-height: 40px;'>
                    <el-radio :label="1">按规则推送</el-radio>
                    <el-radio :label="2">按用户推送</el-radio>
                </el-radio-group>
                <el-form-item label="归属科室：" v-show='selectVal.rule==1'>
                    <el-radio-group v-removeAriaHidden v-model='selectVal.departmentStatus'>
                        <el-radio :label="0">选择科室</el-radio>
                        <el-radio :label="1">不限</el-radio>
                    </el-radio-group>
                    <div v-show='selectVal.departmentStatus===0'>
                        <div class="tag-wrap">
                            <el-tag closable type="success"
                             v-for='(item,index) in selectVal.pushDepartment'
                              :key='index' class='self-tag-item'
                              @close='formTagCloseHandle(0, index)'>
                                {{item.name}}
                            </el-tag>
                        </div>
                        <el-button type='primary' size='mini' plain
                         @click='addTags(0)'>
                        添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="适合职称：" v-show='selectVal.rule==1'>
                    <el-radio-group v-removeAriaHidden v-model='selectVal.courseJobtitleStatus'>
                        <el-radio :label="0">选择职称</el-radio>
                        <el-radio :label="1">不限</el-radio>
                    </el-radio-group>
                    <div v-show='selectVal.courseJobtitleStatus===0'>
                        <div class="tag-wrap">
                            <el-tag closable type="success"
                             v-for='(item,index) in selectVal.pushJobTitle'
                              :key='index' class='self-tag-item'
                              @close='formTagCloseHandle(1, index)'>
                                {{item.name}}
                            </el-tag>
                        </div>
                        <el-button type='primary' size='mini' plain
                        @click='addTags(1)'>
                        添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="地区选择：" v-show='selectVal.rule==1'>
                    <el-radio-group v-removeAriaHidden v-model='selectVal.courseAreaStatus'>
                        <el-radio :label="0">选择城市</el-radio>
                        <el-radio :label="1">不限</el-radio>
                    </el-radio-group>
                    <div v-show='selectVal.courseAreaStatus===0'>
                        <div class="tag-wrap">
                            <el-tag closable type="success"
                             v-for='(item,index) in selectVal.areas'
                              :key='index' class='self-tag-item'
                              @close='formTagCloseHandle(2, index)'>
                                {{item.name}}
                            </el-tag>
                        </div>
                        <el-button type='primary' size='mini' plain
                        @click='addTags(2)'>
                        添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="用户类型：" v-show='selectVal.rule==1'>
                    <el-radio-group v-removeAriaHidden v-model='selectVal.userTypeStatus'>
                        <el-radio :label="0">选择用户</el-radio>
                        <el-radio :label="1">不限</el-radio>
                    </el-radio-group>
                    <div v-show='selectVal.userTypeStatus===0'>
                        <div class="tag-wrap">
                            <el-tag closable type="success"
                             v-for='(item,index) in selectVal.userType'
                              :key='index' class='self-tag-item'
                              @close='formTagCloseHandle(3, index)'>
                                {{item.name}}
                            </el-tag>
                        </div>
                        <el-button type='primary' size='mini' plain
                        @click='addTags(3)'>
                        添加</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="下载模板：" v-show='selectVal.rule==2'>
                	<a :href="requestApi.down"><el-button type="text" size='small'>模板文件</el-button></a>
                </el-form-item>
                <el-form-item label="推送用户：" v-show='selectVal.rule==2'>
                	<el-button type="success" plain size='small'
						 style='margin: 10px 0;position: relative;'>
							选择文件
                		<input class="uploadBtn" type="file" @change="sendfile($event)">
					</el-button>
					<span>{{pushExcelName}}</span>
                </el-form-item>
                <el-card class="col" style="width: 400px;margin: 20px 0 20px 100px;"
                 v-show='total&&selectVal.rule==2'>
					<p>已导入 {{total}} 位用户</p>
				</el-card>
                <el-form-item style="margin: 20px 0;">
                     <el-button type='info' @click='closePage'>取 消</el-button>
                     <el-button type='primary' @click='createPush'
                      :loading="singleSubmit">确 认</el-button>
                </el-form-item>
            </el-form>
            <!-- 归属科室&职称&城市 -->
            <el-dialog :title="dialogTags.title"
             :visible.sync="dialogTags.show" center>
                <el-form label-width="120px">
	                <el-form-item label="请选择省份："
	                 v-if='dialogTags.id==2'>
	                    <el-select v-model='provinceVal'
	                    	@change='provinceChange'>
	                        <el-option v-for='(item, index) in province' :key="item.code" :value="item.code" :label="item.name"></el-option>
	                    </el-select>
	                </el-form-item>
                    <el-form-item :label="dialogTags.orignName">
                        <div class="tag-wrap">
                            <span v-for='(item, index) in dialogTags.orignTags'
                             :key="index" @click="choiceTagHandle(index)">
                                <el-tag :class="[item.choiced === true ? 'self-tag-choiced' : '','self-tag-item']">{{item.name}}</el-tag>
                            </span>
                        </div>
                    </el-form-item>
                    <el-form-item :label="dialogTags.chooseName">
                        <div class="tag-wrap">
                            <span v-for='(item, index) in dialogTags.chooseTags'
                             :key="index">
                                <el-tag class='self-tag-item' type='success' closable @close='cancleChoiceTag(index, item.id)'>{{item.name}}</el-tag>
                            </span>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogTags.show = false">取 消</el-button>
                    <el-button type="primary" @click="tagDialogSubmit">确 定</el-button>
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>

<script scoped>
	import commonApi from "@/api/common"
  	import pageRouter from "@/utils/pageRouter"
    import datetime from '@/components/datetime'
    import requestApi from '@/api/operateManage/contentPush'
    import XLSX from 'xlsx'
	import { mapGetters } from "vuex";
    export default {
        name: "pushEdit",
        components: {
            datetime
        },
        props: {
            PAGEKEY: {
                type: String,
                default: () => ''
            },
            PAGEBACK: {
                type: String,
                default: () => ''
            }
        },
        data() {
        	var timeValidator = (rule, value, callback) => {
		        if(this.$refs.datetime.getTime === ''){
		            callback(new Error('请选择时间'))
		        }else{
		            callback()
		        }
		    }
            return {
            	requestApi: requestApi,
      			commonUrl: commonApi.commonUrl,
                pushId: '',
            	singleSubmit: false,
            	selectVal: {
            		title: '',	//标题
                    content: '',	//内容
            		pushTime: '',	//推送时间
            		contentType: 6,	//内容类型
            		command: '',	//指令
            		rule: 1, // 1按规则推送 2按用户推送
            		areas: [],	//地区
            		pushJobTitle: [], //职称
            		pushDepartment: [], //科室
                    userType: [], //用户类型

            		departmentStatus: 1,	//选择科室
		      		courseAreaStatus: 1,	//地区
		      		courseJobtitleStatus: 1, //选择职称
                    userTypeStatus: 1, //选择用户
            	},
            	rules: {
					title: { required: true, message: '请输入标题', trigger: 'blur' },
					content: { required: true, message: '请输入内容', trigger: 'blur' },
					pushTime: { validator: timeValidator, trigger: 'blur' },
					command: { required: true, message: '请输入指令', trigger: 'blur' }
            	},
            	departDialog: {
		      		id: 0,
		      		title: '归属科室',
		      		orignName: '请选择科室',
		      		orignTags: [],
		      		chooseName: '已选择科室',
		      		chooseTags: [],
		      		show: true
		      	},
		      	jobDialog: {
		      		id: 1,
		      		title: '适合职称',
		      		orignName: '请选择职称',
		      		orignTags: [],
		      		chooseName: '已选择职称',
		      		chooseTags: [],
		      		show: true
		      	},
		      	cityDialog: {
		      		id: 2,
		      		title: '适合城市',
		      		orignName: '请选择城市',
		      		orignTags: [],
		      		chooseName: '已选择城市',
		      		chooseTags: [],
		      		show: true
		      	},
                userTypeDialog: {
                    id: 3,
		      		title: '用户类型',
		      		orignName: '请选择用户类型',
		      		orignTags: [],
		      		chooseName: '已选择用户',
		      		chooseTags: [],
		      		show: true
                },
		      	dialogTags: {
		      		id: '',
		      		title: '',
		      		orignName: '',
		      		orignTags: [],
		      		chooseName: '',
		      		chooseTags: [],
		      		show: false
		      	},
            	addCommandTab: {
            		code: "command",
		          	name: "生成指令",
			        root: "operateManage"
            	},
		     	province: [{
		     		code: '',
		     		name: '全部省份'
		     	}],
		     	provinceVal: '',
		     	allCitys: '',
		     	// 上传文件
		     	pushExcelName: '',
		     	excelObj: "",
		     	success: 0,
      			error: 0,
      			total: 0,
      			errorList: [],
      			data: {}
            }
        },
		computed: {
			...mapGetters("user", {
				USERNAME: "userName"
			})
		},
        mounted(){
		    this.getSelect()
		    this.getProvinceList()
		    this.getAllCity()
            this.getUserTypes()
			this.addCommandRouter()
        },
        activated() {
            if (this.$route.params.id === this.pushId) {
                return
            }
       		this.pushId = this.$route.params.id
            if(this.pushId) {
                this.getData()
            }

        },
        methods: {
			// 添加路由
			addCommandRouter() {
				pageRouter(this, "command",
				 "operateManage/command/index")
		        .catch(res => {
		        	this.$message.error('指令路由添加失败！')
		        })
			},
		    // 去生成指令
		    goCommand() {
	            this.$store.dispatch("tabs/switchTab_single",
	            this.addCommandTab)
		    },
			//获取省列表
			getProvinceList() {
				commonApi.getProvince().then(res => {
					if(res.Success){
						res.Data.unshift({code:'',name:'全部省', isopen: true})
						this.province = res.Data
					}else{
						this.$message.error(res.Msg)
					}
				})
			},
        	//获取科室、职称、职位等list
		    getSelect() {
		    	commonApi.getSelect().then(res => {
		    		if(res.Success){
		    			this.departDialog.orignTags = res.Data.departmentsSelect
		    			this.jobDialog.orignTags = res.Data.jobTitleSelect
		    		}else{
		    			this.$message.error(res.Msg)
		    		}
		    	}).catch(res => {
		    		this.$message.error('获取职位科室出错！')
		    	})
		    },
		    provinceChange(val) {
		    	if(val !== ''){
					commonApi.getCityOrArea(this.provinceVal).then(res => {
						if(res.Success){
							this.dialogTags.orignTags = res.Data
						}else{
							this.$message.error(res.Msg)
						}
					})
				}else{
					this.dialogTags.orignTags = JSON.parse(JSON.stringify(this.allCitys))
				}
		    },
		    // 获取所有城市
		    getAllCity() {
		    	commonApi.getAllCity().then(res => {
		    		if(res.Success){
		                this.cityDialog.orignTags = res.Data.dataList
		                this.allCitys = res.Data.dataList
		    		}else{
		    			this.$message.error(res.Msg)
		    		}
		    	}).catch(res => {
		    		this.$message.error('获取城市列表出错！')
		    	})
		    },
            // 获取用户类型
            getUserTypes() {
                this.userTypeDialog.orignTags = [
                    {id: 'yearVip', name: '年卡会员'},
                    {id: 'shortVip', name: '非年卡会员'},
                    {id: 'superVip', name: '超级会员'},
                    {id: 'gynVip', name: '妇科会员'},
                    {id: 'obVip', name: '产科会员'},
                    {id: 'pefVip', name: '儿科会员'},
                    {id: 'ndVip', name: '护理会员'},
                    {id: 'madVip', name: '医管会员'},
                    {id: 'spsVip', name: '私密会员'},
                    {id: 'aauVip', name: '年活跃用户'},
                    {id: 'nonVip', name: '非会员标签'},
					{id: 'groupBuyVip', name: '团购会员'},
					{id: 'individualVip', name: '个人会员'}
                ]
            },
		    // 添加科室职称地区按钮
		    addTags(id) {
		    	let data = {}
		    	switch(id){
		    		case 0: data = this.departDialog,
		                data.chooseTags = this.selectVal.pushDepartment; break;
		    		case 1: data = this.jobDialog,
		                data.chooseTags = this.selectVal.pushJobTitle; break;
		    		case 2: data = this.cityDialog,this.provinceVal='',
		                data.chooseTags = this.selectVal.areas; break;
		    		case 3: data = this.userTypeDialog,
		                data.chooseTags = this.selectVal.userType; break;
		    		default: break;
		    	}
		    	this.dialogTags = JSON.parse(JSON.stringify(data))
		    },
		    //标签选择钩子
		    choiceTagHandle(index) {
                let origin = this.dialogTags.orignTags[index]
                let chooseTagsString = JSON.stringify(this.dialogTags.chooseTags)
                if (chooseTagsString.includes(origin.id)) {
                    origin.choiced = true
                    this.$forceUpdate()
                } else {
                    origin.choiced
                    = !origin.choiced;
                    this.dialogTags.chooseTags.push(origin);
                }
		    },
		    //取消选择
		    cancleChoiceTag(index, id) {
		      this.dialogTags.chooseTags.splice(index, 1);
		      for (var i = 0; i < this.dialogTags.orignTags.length; i++) {
		        if (this.dialogTags.orignTags[i].id == id) {
		          this.dialogTags.orignTags[i].choiced = false;
		          break;
		        }
		      }
		    },
		    // 标签确定
		    tagDialogSubmit() {
		      this.dialogTags.show = false
		      let data = JSON.parse(JSON.stringify(this.dialogTags.chooseTags))
		      switch(this.dialogTags.id){
		        case 0: this.selectVal.pushDepartment = data; break;
		        case 1: this.selectVal.pushJobTitle = data; ;break;
		        case 2: this.selectVal.areas = data; ;break;
		        case 3: this.selectVal.userType = data; ;break;
		        default: break;
		      }
		    },
		    // 标签取消
		    formTagCloseHandle(id,index) {
		        switch(id){
		            case 0: this.selectVal.pushDepartment.splice(index, 1); break;
		            case 1: this.selectVal.pushJobTitle.splice(index, 1); break;
		            case 2: this.selectVal.areas.splice(index, 1); break;
		            case 3: this.selectVal.userType.splice(index, 1); break;
		            default: break;
		        }
        		this.$forceUpdate()
		    },
		    // 获取修改数据
		    getData() {
				requestApi.getPush({id: this.pushId}).then(res => {
		    		if(res.Success){
		    			this.selectVal.title = res.Data.title	//标题
		            	this.selectVal.pushTime = res.Data.pushTime	//推送时间
		            	this.selectVal.command = res.Data.instruct	//指令
		            	this.selectVal.rule = res.Data.pushType
		            	this.selectVal.content = res.Data.content

		            	if(res.Data.phoneList){
		            		this.excelObj = res.Data.phoneList
		            		this.total = res.Data.phoneList.length
		            	}
		            	//地区
				    	if(res.Data.filter&&res.Data.filter.cityCodeList){
				    		this.selectVal.courseAreaStatus = 0
				    		let areas = res.Data.filter.cityCodeList
				    		this.cityExchange(areas)
				    	}else{
				    		this.selectVal.courseAreaStatus = 1
				    		this.selectVal.areas = []
				    	}
				    	// 科室
				    	if(res.Data.filter&&res.Data.filter.departmentsList){
				    		this.selectVal.departmentStatus = 0
				    		let pushDepartment = res.Data.filter.departmentsList
				    		this.departExchange(pushDepartment)
				    	}else{
				    		this.selectVal.departmentStatus = 1
				    		this.selectVal.pushDepartment = []
				    	}
				    	// 职称
				    	if(res.Data.filter&&res.Data.filter.jobTitleList){
				    		this.selectVal.courseJobtitleStatus = 0
				    		let pushJobTitle = res.Data.filter.jobTitleList
				    		this.jobTitleExchange(pushJobTitle)
				    	}else{
				    		this.selectVal.courseJobtitleStatus = 1
				    		this.selectVal.pushJobTitle = []
				    	}
				    	// 用户类型
				    	if(res.Data.filter&&res.Data.filter.vipTags){
				    		this.selectVal.userTypeStatus = 0
				    		let userType = res.Data.filter.vipTags
				    		this.userTypeExchange(userType)
						}else{
				    		this.selectVal.userTypeStatus = 1
				    		this.selectVal.userType = []
				    	}
		    		}else{
		    			this.$message.error(res.Msg)
		    		}
		    	}).catch(res => {
		    		console.log(res)
		    		this.$message.error('获取数据出错，请稍后再试！')
		    	})
		    },
		    // 创建
		    createPush() {
		    	this.$refs.addPush.validate((valid) => {
            		if (valid) {
				    	let data = {
							title: this.selectVal.title,
                            content: this.selectVal.content,
							pushTime: this.$moment(this.$refs.datetime.getTime).
								format('YYYY-MM-DD HH:mm:ss'),
							propagandaUrl: this.selectVal.instruct,
							pushType: this.selectVal.rule,
							instruct: this.selectVal.command,
							filter: {}
				    	}
						if(this.pushId) { data.id = this.pushId }
				    	if(this.selectVal.rule === 1){//按规则推送
							data.filter.cityCodes = this.selectVal.courseAreaStatus===1?[]
				    			:this.selectVal.areas.map(item => item.code || item.id)
							data.filter.departmentsIds = this.selectVal.departmentStatus===1?[]
				    			:this.selectVal.pushDepartment.map(item => item.id)
							data.filter.jobTitleIds = this.selectVal.courseJobtitleStatus===1?[]
				    			:this.selectVal.pushJobTitle.map(item => item.id)
							data.filter.vipTags = this.selectVal.userTypeStatus===1?[]
				    			:this.selectVal.userType.map(item => item.id)
					    	data.phoneList = []
				    	}else{//按用户推送
				    		data.phoneList = this.excelObj
				    		data.filter = {
								vipTags: [],
								cityCodes: [],
								jobTitleIds: [],
								departmentsIds: []
							}
				    		if(!data.phoneList) {
				    			this.$message.warning("请导入用户")
				    			return
				    		}
				    	}
				    	this.singleSubmit = true
		                requestApi.createPush(data).then(res => {
		                    if(res.Success){
				    			this.singleSubmit = false
		                    	this.$message.success('添加成功！')
		                    	this.closePage()
		                    }else{
				    			this.singleSubmit = false
		                        this.$message.error(res.Msg)
		                    }
		                }).catch(res => {
				    		this.singleSubmit = false
		                    this.$message.error('添加出错，请稍后再试')
		                })
            		}
            	})
		    },
		    // 地区转换
		    cityExchange(data) {
				this.selectVal.areas = data
		    },
		    // 科室转换
		    departExchange(data) {
				this.selectVal.pushDepartment = data
		    },
		    // 职称转换
		    jobTitleExchange(data) {
				this.selectVal.pushJobTitle = data
		    },
			// 用户类型转换
			userTypeExchange(data) {
				this.selectVal.userType = this.userTypeDialog.orignTags.filter(item => {
					return data.includes(item.id)
				})
			},
		    // 上传文件
		    sendfile(obj) {
		    	obj = obj.currentTarget
				var zzexcel;
				var res = '';
				if(!obj || !obj.files || !obj.files.length) {
					return;
				}
				var f = obj.files[0];
				var reader = new FileReader();
				reader.readAsBinaryString(f);
				this.pushExcelName = f.name
				this.$message.warning('正在上传，请稍后...')
				var _this = this
				reader.onload = function(e) {
					var data = e.target.result;
						zzexcel = XLSX.read(data, {
							type: 'binary'
						});
					res = XLSX.utils.sheet_to_json(zzexcel.Sheets[zzexcel.SheetNames[0]])
					// 对象数组转数组
					let arr = []
					_this.total = res.length
					for(let i = 0; i < res.length; i++) {
						arr[i] = res[i]['手机号(从第二行开始)']
					}
					// _this.excelObj = arr.join(',')
					_this.excelObj = arr
					_this.$message.success('上传成功')
				}
			},
		    // 关闭tab
		    closePage() {
		      	this.$store.dispatch("tabs/removeSpecifiedTab", this.PAGEKEY)
		      	this.$store.dispatch("tabs/toTargetTab", this.PAGEBACK)
		    }
        }
    };
</script>

<style type="text/less" lang="less" scoped>
	.tag-wrap {
		max-height: 200px;
		overflow-y: auto;
	  .self-tag-item {
	    cursor: pointer;
	    margin-right: 10px;
        margin-bottom: 5px;
	  }
	  .self-tag-choiced {
	    display: none;
	  }
	}
	.click_word{
		color: #409EFF;
		cursor: pointer;
		text-decoration: underline;
	}
	/deep/ .el-form-item{
		margin-bottom: 0;
	}
	.uploadBtn{
		height: 100%;
	    width: 100%;
	    position: absolute;
	    top: 0;
	    left: 0;
	    opacity: 0;
	    cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/contentPush/components/pushEdit.vue